import { useGlobalStore } from '@shared/store';
import { useBrowserLocation } from '@vueuse/core';

// 打开隐私协议页面
export const usePrivacyAgreementPage = () => {
  try {
    // 当前页面链接信息
    const { origin = '', pathname = '', href = '' } = useBrowserLocation().value;

    // 隐私协议页面路径
    const privacyAgreementPath = '/caizhi_webapp/privacyAgreement';

    // 当前页面不是隐私协议页时，执行跳转
    if (!pathname?.includes(privacyAgreementPath)) {
      const globalStore = useGlobalStore();
      const { appData, firstEntryStaffId = '' } = globalStore;
      const { currentCorpId = '', agentId = '' } = appData || {};
      location.replace(
        `${
          import.meta.env.VITE_SITE_HOST || origin
        }${privacyAgreementPath}?currentCorpId=${currentCorpId}&agentId=${agentId}&staffId=${firstEntryStaffId}&targetUrl=${encodeURIComponent(
          href
        )}`
      );
    }
  } catch (error) {
    console.log('打开隐私协议页面出错：', error);
  }
};
